import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { window } from '../../helpers/BrowserHelpers';
import { LinkIcon } from '../Icons';
import TooltipOnHover from '../TooltipOnHover';
var SUPPORTED_PROVIDERS = ['drawio'];

var Iframe =
/*#__PURE__*/
function (_Component) {
  _inherits(Iframe, _Component);

  function Iframe() {
    _classCallCheck(this, Iframe);

    return _possibleConstructorReturn(this, _getPrototypeOf(Iframe).apply(this, arguments));
  }

  _createClass(Iframe, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // Rather than Mount for Iframely lazy load players to load
      if (this.props.embedHtmlCode && window.iframely && !this.isLoaded) {
        window.iframely.load();
        this.isLoaded = true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          title = _this$props.title,
          provider = _this$props.provider,
          embedHtmlCode = _this$props.embedHtmlCode;

      if (SUPPORTED_PROVIDERS.includes(provider)) {
        return React.createElement("div", {
          style: {
            width: '100%',
            paddingBottom: '75%'
          }
        }, React.createElement("iframe", {
          className: "position-absolute width-full height-full",
          title: provider || url,
          src: url,
          frameBorder: 0,
          style: {
            display: 'block'
          }
        }));
      } else if (!embedHtmlCode) {
        return React.createElement("a", {
          href: url,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "flexbox shade-00 flexbox-align-center pointer ellipsis padding-medium"
        }, React.createElement("div", {
          className: "flexbox flexbox-centered pointer shade-30 padding-right-normal"
        }, React.createElement(TooltipOnHover, {
          placement: "top",
          tooltipContent: "No preview available for this embed"
        }, React.createElement(LinkIcon, {
          size: 24
        }))), React.createElement("div", {
          className: "flexbox-grow ellipsis"
        }, React.createElement("div", {
          className: "font-weight-bold ellipsis"
        }, title), React.createElement("div", {
          className: "shade-20 primary-on-hover ellipsis"
        }, provider || url)));
      }

      return React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: embedHtmlCode
        }
      });
    }
  }]);

  return Iframe;
}(Component);

_defineProperty(Iframe, "propTypes", {
  embedHtmlCode: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  provider: PropTypes.string
});

export default Iframe;